import React from 'react';
import Icon from '@ant-design/icons';

// Created with Inkscape (http://www.inkscape.org/)

const WaveLayerSvg = () => (
  <svg
    version="1.1"
    id="svg1"
    width="1.8em"
    height="1.8em"
    viewBox="0 0 57.333332 37.333332"
  >
    <defs id="defs1" />
    <g id="layer1">
      <path
        style={{
          fill: '#ffff0000',
          fillRule: 'evenodd',
          stroke: 'currentColor',
          strokeOpacity: 0.95,
          strokeWidth: 1.8,
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
        }}
        d="m 15.413267,14.721054 c 0,0 2.810812,-1.117043 4.291718,-1.153687 2.108329,-0.05217 4.488272,0.08406 6.183766,1.338277 1.19035,0.880547 1.908037,2.418917 2.168932,3.876391 0.19206,1.072934 -0.08436,2.225872 -0.507622,3.230325 -0.678566,1.610325 -2.030483,2.847781 -3.138031,4.199423 -0.890628,1.086916 -1.774535,2.193551 -2.814997,3.138031 -1.018282,0.924346 -2.187048,1.670066 -3.322621,2.445817 -0.736477,0.503114 -2.261228,1.430573 -2.261228,1.430573 l -0.358943,0.26105"
        id="path3"
      />
      <path
        style={{
          fill: '#ffff0000',
          fillRule: 'evenodd',
          stroke: 'currentColor',
          strokeOpacity: 0.95,
          strokeWidth: 1.8,
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
        }}
        d="m 27.642356,27.273176 v 0 c 0,0 0.976549,-1.587812 1.753605,-2.03049 0.909756,-0.51828 2.045235,-0.58197 3.091883,-0.55377 1.074186,0.02894 2.171799,0.268137 3.13803,0.73836 1.328478,0.646512 2.263543,1.90353 3.461063,2.76885 1.532002,1.107014 3.09218,2.189916 4.753193,3.091883 1.597646,0.867557 3.470298,1.079986 3.470298,1.079986 0,0 -0.860852,-0.629973 -2.039725,-1.679904 C 43.777863,29.358533 42.464969,27.78993 41.44046,26.073341 40.428893,24.378436 39.938083,22.422447 39.22538,20.581788 38.443331,18.562031 37.955292,16.416105 36.964152,14.490317 36.14805,12.904629 35.202763,11.343624 33.964564,10.060156 33.276713,9.3471576 32.47511,8.6977188 31.564894,8.306551 30.070766,7.6644454 28.391506,7.4612978 26.765553,7.4297484 25.786801,7.410757 24.800653,7.5801009 23.85826,7.845076 c -1.386374,0.3898104 -2.692924,1.0393103 -3.968685,1.7074577 -0.899883,0.4712913 -1.448827,0.9021103 -2.21508,1.5690143 -0.650714,0.566345 -1.586163,1.291067 -2.030491,2.030491 -0.316328,0.526413 -0.57467,1.104666 -0.692212,1.707458 -0.02944,0.150981 0,0.461475 0,0.461475"
        id="path4"
      />
      <path
        style={{
          fill: '#ffff0000',
          fillRule: 'evenodd',
          stroke: 'currentColor',
          strokeOpacity: 0.95,
          strokeWidth: 1.8,
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
        }}
        d="m 28.161656,26.511941 -0.473153,0.66894 c 0,0 1.566105,-0.501807 2.307376,-0.276885 0.407129,0.123535 0.819164,0.43249 0.969097,0.830655 0.421641,1.119722 -0.02158,2.460048 -0.507622,3.553358 -0.390434,0.878255 -1.044994,1.683745 -1.845901,2.21508 -0.924512,0.613337 -2.081125,0.850018 -3.184177,0.969098 -2.286131,0.2468 -4.591688,-0.290483 -6.875979,-0.55377 -2.982405,-0.343751 -8.9498867,-1.488568 -8.9498867,-1.488568 0,0 4.4502957,-2.917021 6.2733307,-4.833641 1.212848,-1.275108 2.57323,-2.578867 3.138031,-4.24557 0.582645,-1.719357 0.551215,-3.688972 0.0923,-5.445406 -0.216085,-0.827039 -1.001297,-1.529653 -1.47672,-1.8459 -0.387122,-0.257511 -1.442984,-0.632505 -2.261228,-0.599918 -0.889488,0.03543 -1.524538,0.22226 -2.307375,0.646065 -0.574236,0.310876 -1.158933,1.233083 -1.384426,1.753606 -0.32525,0.7508 -0.811973,2.517781 -1.153687,4.014833 -0.06725,0.29464 -0.138443,0.646064 -0.138443,0.646064 0,0 -1.616807,-1.815322 -1.8458994,-2.95344 C 8.2945845,18.360777 8.1234541,17.471439 8.1681135,16.382365 8.2109155,15.33859 8.5561554,14.320791 8.9064736,13.336629 9.301018,12.22822 9.7841218,11.136284 10.429341,10.152451 11.021356,9.2497445 11.738958,8.4166446 12.552127,7.7066334 13.313802,7.0415838 14.9822,6.4129562 15.967042,6.1837657 c 0.843344,-0.1962614 4.658223,-0.4659166 7.706633,-0.092295 0.570469,0.069918 1.328957,0.3487351 1.845901,0.5999176 0.450079,0.2186927 1.430573,0.8306551 1.430573,0.8306551"
        id="path5"
      />
    </g>
  </svg>
);

const WaveLayerIcon = (props) => <Icon component={WaveLayerSvg} {...props} />;

export default WaveLayerIcon;
